import React, { CSSProperties } from "react";
import { IETrState } from "./Interfaces";
import { ContainerEl } from "./index";

class ETr extends ContainerEl<HTMLTableRowElement, IETrState> {
    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
        };

        return styles;
    };

    render() {
        const { Brand, ...rest } = this.props;
        return (
            <tr style={this.__setStyle(this.getStyles())} {...rest}>
                {this.__passPropsToChildren({ Brand: Brand })}
            </tr>
        );
    }
}

export { ETr };
